// extracted by mini-css-extract-plugin
export default {"emptyContent":"GamesContent__emptyContent--1PV","gamesGridCategories":"GamesContent__gamesGridCategories--3W9"};